
import * as React from 'react';
import { MdArrowDropDown, MdFolder } from 'react-icons/md';

import { Tooltip } from 'ui/common/tooltip/tooltip';
import { Link } from 'react-router-dom';
import { MeatballMenu } from 'ui';
import styles from './select-option-link.scss';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
import { SelectOptionValue } from 'app/area/code-selector/types';
import * as navigate from 'app/area/shared/navigation';
import { useEffect, useState } from 'react';

export interface SelectOptionLinkProps {
  data: SelectOptionValue;
  onClick?: (itemId: number) => void;
  onExpand: (item: SelectOptionValue) => void;
  urlResolver: (value: number[]) => Object;
  dropdownItems?: React.ReactNode;
  labelItems?: React.ReactNode;
  defaultIcon?: React.ReactNode;
  selectedItem?: number;
  itemBookmark?: React.ReactNode;
}

export const SelectOptionLink = (props: SelectOptionLinkProps)=> {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [src, setSrc] = useState('');
  
  const onClick = (e: React.MouseEvent<any>) => {
    if (props.onClick) {
      e.preventDefault();
      props.onClick(props.data.value);
    }
  };

  const expandDropdown = () => {
    setDropdownOpen(true);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const onExpand = (e: any) => {
    e.preventDefault();
    props.onExpand(props.data);
    navigate.toSelectSavedReports(props.data.value);
  };
  
  const { urlResolver, data, dropdownItems, labelItems, defaultIcon, selectedItem, itemBookmark } = props;

  useEffect(() => {
    setSrc(data?.icon);
  }, []);
  
  const icon = !!data.icon ? <img className={`${styles.selectCodeBtnIcon}`} src={src} /> : defaultIcon;
  const folder = <MdFolder className={`${styles.selectCodeBtnIcon} ${styles.defaultIcon}`} />;
  const isFolder = !!data.descendants;
  const folderClickHandler = isFolder ? onExpand : onClick;
  const url = urlResolver && urlResolver([data.value]);
  const isSelected = selectedItem && data?.value && (selectedItem === data?.value);
  const itemBookmarkInlineStyle = data.bookmark ? styles.itemBookmarkedContainer : styles.itemContainer;

  return (<li className={`col-6 col-md-4 col-lg-3 col-xl-2 ${styles.selectOption} ${dropdownOpen ? styles.expanded : ''} select-option`} 
    onMouseLeave={closeDropdown}>
    {dropdownItems && <div className={`${styles.meatballContainer}`}>
      <MeatballMenu className={`${isFolder && styles.whiteDots} ${isSelected && styles.isSelectedMeatballMenu}`} 
        onExpandMenu={expandDropdown} onCloseMenu={closeDropdown} closeOnDemand={dropdownOpen}>
        {dropdownItems}
      </MeatballMenu>
    </div>}
    {labelItems && <div className={styles.labelContainer}>{labelItems}</div>}
    <div className={`${isSelected && styles.isSelectedTooltip} ${styles.selectLinkContainer}`}>
      <Link to={!isFolder ? url : '#'} onClick={folderClickHandler}>
        <Tooltip className={`${styles.selectCodeBtn} ${isFolder && styles.selectFolder}`}
          title={data.longDescription} wide>
            {isFolder ? folder : icon}
            <span className={`${styles.selectCodeBtnTitle}`}>
              {insertOptionalWordbreaks(data.description)}{isFolder && <MdArrowDropDown />}
            </span>
        </Tooltip>
        <span className={`${itemBookmarkInlineStyle} ${isSelected && styles.isSelectedBookmark}`}>{itemBookmark}</span>
      </Link>
    </div>
  </li>);
};
